export default __webpack_public_path__ + "static/media/fertilizer.aafbc100.svg";